import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (templateId: string) => {
      await request({
        path: `template/${templateId}`,
        method: 'DELETE',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-templates'] });
      toast.success('Template deleted successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error deleting template!');
    },
  });
};
